import { NgModule } from "@angular/core";
import { TestimonialsPanelInfoComponent } from "./testimonials-panel-info.component";
import { CommonModule } from "@angular/common";
import { SharedModule } from "src/app/shared/shared.module";
import { TranslateModule } from "@ngx-translate/core";

@NgModule({
  imports: [CommonModule, SharedModule, TranslateModule],
  exports: [TestimonialsPanelInfoComponent],
  declarations: [TestimonialsPanelInfoComponent],
})
export class TestimonialsPanelInfoModule { }
